<template>
  <v-navigation-drawer v-model="drawer" app clipped>
    <v-list dense>
      <v-list-item link to="/users/dashboard">
        <v-list-item-action>
          <v-icon>mdi-blur-radial</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-if="currentExercises">
        <v-list-item
          link
          :to="`/users/project/${$route.params.id}/${item.slug}`"
          v-for="item in currentExercises"
          :key="item.id"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
export default {
  name: "SidebarUser",
  data() {
    return {
      drawer: this.value,
    };
  },
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState(["currentUser", "currentProject", "currentExercises"]),
  },
  watch: {
    value: {
      handler: function(val) {
        this.drawer = val;
      },
      deep: true,
    },
  },
};
</script>
